import * as yup from 'yup';

export const billingAddressSchema = yup.object().shape({
	firstName: yup
		.string()
		.required('firstName.required')
		.max(50, 'firstName.max'),
	lastName: yup.string().required('lastName.required').max(50, 'lastName.max'),
	company: yup.string().max(30, 'company.max'),
	street: yup.string().required('street.required').max(100, 'street.max'),
	streetNumber: yup
		.string()
		.required('streetNumber.required')
		.max(6, 'streetNumber.max'),
	postCode: yup
		.string()
		.trim()
		.required('postCode.required')
		.matches(/[0-9]{4,5}/i, { message: 'postCode.incorrect' })
		.min(4, 'postCode.incorrect')
		.max(5, 'postCode.incorrect'),
	location: yup.string().required('location.required').max(100, 'location.max'),
});
